export const WHITE = '#fff'
export const LLL_GRAY = '#f7f7f7'
export const LL_GRAY = '#efefef'
export const L_GRAY = '#ddd'
export const G_GRAY = '#cccccc'
export const M_GRAY = '#c1c1c1'
export const D_GRAY = '#a1a0a0'
export const DD_GRAY = '#666666'
export const DDD_GRAY = '#5a5a5a'
export const D_BLACK = '#111'
export const BLACK = '#000'

export const LL_CYAN = '#f0fbff'
export const L_CYAN = '#48c0ec'
export const CYAN = '#00a7e5'
export const D_CYAN = '#0098cc'
export const IGS_BLUE = '#00609c'
export const FADED_BLUE = '#3f97b5'
export const LL_FADED_BLUE = '#e1edf1'
export const L_FADED_BLUE = '#6fb1c7'
export const L_ORANGE = '#ffc47a'
export const BOOT_BLUE = '#66afe9'
export const BLUE = '#00609c'
export const D_BLUE = '#005083'
export const DD_BLUE = '#004169'
export const DDD_BLUE = '#002b45'
export const ORANGE = '#fc9708'
export const LL_GREEN = '#dff1d8'
export const L_GREEN = '#c0de8d'
export const GREEN = '#81bb01'
export const D_GREEN = '#3c763d'
export const L_BROWN = '#dfd29b'
export const BROWN = '#b38e2e'
export const D_BROWN = '#8a6d3c'
export const L_RED = '#f3dede'
export const RED = '#d4a6a5'
export const D_RED = '#a94442'
export const YELLOW = '#fff8d9'
export const D_PURPLE = '#8179AB'
export const DEEP_PURPLE = '#3c1053'
export const L_PURPLE = '#cc93eb'

export const ENVIRONMENT_BACKGROUND = '#0000FF'



// WEBPACK FOOTER //
// ./src/style/colors.ts